/*eslint-disable  no-unused-vars */
import moment from 'moment'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Button, Card, CardBody, CardHeader, Col, Row } from 'reactstrap'
import {
  removeFiltersValues,
  setFiltersOnLoad,
  setFiltersValue,
} from '../../../common/ContactCommonComponents/AdvanceSearch/redux/ContactFiltersActions'
import SelectingFilters from '../../../common/ContactCommonComponents/AdvanceSearch/SelectingFilters'
import ExcelButton from '../../../common/CustomButtons/ExcelButton'
import CustomDropDownFilters from '../../../common/CustomDropDownForFilters'
import CustomModal from '../../../common/CustomModal/CustomModal'
import CustomPopupModal from '../../../common/CustomPopupModal/CustomPopupModal'
import { setModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../../common/PrimeTable/CustomPrimeTable'
import { OUT_GOING_CALL } from '../../../constants/activityTypes'
import { getAmericaStateName } from '../../../constants/americaStates'
import { CONTACT } from '../../../constants/contactCategory'
import { EXCEL_DEFAULT_LIMIT } from '../../../constants/excelContants'
import {
  CAN_UPLOAD_NEW_LEADS,
  CHANGE_CONTACT_STATUS,
  DELETE_CONTACT as DELETE_CONTACT_PERMISSION,
  BRANCH_MANAGER,
  IS_EXECUTIVE,
  MANAGER,
} from '../../../constants/permissions'
import { COLUMN_RESIZE_EXPAND } from '../../../constants/primeTableConstants'
import {
  ACCOUNT_STATUS,
  INACTIVE_STATUS,
  LEAD_STATUS,
  MANAGER_BUCKET_STATUS,
  PENDING_STATUS,
  PROSPECT_STATUS,
} from '../../../constants/statuses'
import { isEmptyArray, isNotEmptyArray } from '../../../utils/arrayUtils'
import { notificationDanger } from '../../../utils/customToastify'
import { filterObject } from '../../../utils/object.utils'
import { timeWithoutTimeZone } from '../../../utils/utcTime'
import CustomNumberFormat from '../../ClickToCall/ClickToCall'
import Loader from '../../Loader'
import {
  assignWithTask,
  deleteContact,
  deleteContacts,
  downloadContacts,
  getAllContacts,
  getOptions,
  unassignContacts,
} from '../redux/ContactActions'
import { isContactAssignable } from '../utils'
import AddNewContact from './AddNewContact'
import DeleteContacts from './DeleteContacts'
import ImportLeads from './ImportLeads'
import SelectUserToAssigne from './SelectUserToAssigne'
import ContactTableFilters from './TableFilters'

const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }

const DEFAULT_SORT_META = [{ field: 'name', order: -1 }]
const defaultSort = { name: -1 }

const EXCEL_OPTIONS = [
  { field: 'name', header: 'Name' },
  { field: 'companytype.name', header: 'Company Type' },
  { field: 'organizationtype.name', header: 'organization type name' },
  { field: 'email', header: 'Email' },
  { field: 'businessPhone', header: 'Office Phone', width: 100 },
]

const URL_PARAM = 'contacts'
const EXCEL_FILE_NAME = 'contactList'

class index extends Component {
  state = {
    options: {
      pagination: DEFAULT_PAGINATION,
      sort: defaultSort,
      filter: {},
      tableFilter: {},
      isModalToggle: false,
      isUserModalToggle: false,
      isLoaded: false,
      companyTypeOptons: [],
      isCombineModalToggle: false,
      isAddContactModal: false,
      isDeleteContactsModalToggle: false,
      isAssignWithTaskToggle: false,
      isExactNameSearch: this.props.tableName === 'All Contacts',
    },
    phoneFilter: '',
    isExcelExportDisabled: false,
  }

  componentDidMount() {
    this.loadDataOnStart()
  }

  loadDataOnStart() {
    /*eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }]*/
    const { history, setFiltersOnLoad } = this.props
    let filtersFromUrl = {}
    let otherFiltersFromUrl = {}
    let optionsFromUrl = {}
    if (history && history.location.search) {
      const decodedSearch = decodeURIComponent(history.location.search)

      filtersFromUrl = JSON.parse(decodedSearch.substring(1))

      const { query, ...restFiltersFromUrl } = filtersFromUrl

      otherFiltersFromUrl = restFiltersFromUrl
      if (query) {
        const { pagination, sort } = query
        if (pagination && sort) {
          optionsFromUrl = { pagination, sort }
        }
      }
      setFiltersOnLoad(otherFiltersFromUrl)
    }

    const { pagination, sort } = optionsFromUrl

    this.props.getOptions()
    let options = {
      ...this.state.options,
      pagination: pagination || DEFAULT_PAGINATION,
      sort: sort || defaultSort,
      tableFilter: { ...otherFiltersFromUrl },
    }

    this.setState({ ...this.state, options }, () => {
      this.props.getAllContacts({ ...this.state.options, tableFilter: otherFiltersFromUrl }, this.props.url)
    })
  }

  static getDerivedStateFromProps(props, state) {
    const {
      isAllContact,
      isDivisionClaimed,
      isToReassign,
      isFollowUp,
      isManagersBucket,
      initialFilter,
      advanceFilters,
      winAgainAccount,
      winAgainProspects,
      isDeadTable,
      isIGiveUp,
      isNotQualifiedTable,
      isUnassignedLead,
      isInactiveAccounts,
    } = props
    if (advanceFilters) {
      return {
        options: {
          ...state.options,
          // tableFilter: { ...advanceFilters },
          filter: { ...initialFilter },
          isAllContact,
          isDivisionClaimed,
          isToReassign,
          isManagersBucket,
          isFollowUp,
          winAgainAccount,
          winAgainProspects,
          isDeadTable,
          isIGiveUp,
          isNotQualifiedTable,
          isUnassignedLead,
          isInactiveAccounts,
        },
      }
    }
    return null
  }

  loadDataWithFilters = async (e) => {
    if (e) {
      e.preventDefault()
    }

    this.props.getAllContacts(this.state.options, this.props.url)
    this.setState((state) => {
      return {
        ...state,
        isLoaded: !state.isLoaded,
        isModalToggle: false,
        isCombineModalToggle: false,
      }
    })
  }

  deleteContact = async (contactId) => {
    let response = null
    if (contactId) {
      response = await this.props.deleteContact(contactId)
    }

    if (response && response.status === 200) {
      this.props.getAllContacts(this.state.options, this.props.url)
    }
  }

  deleteAndLoadDataWithFilters = async () => {
    const ids = this.state.selectedRowsNew?.map((row) => row.id)

    if (isNotEmptyArray(ids)) {
      this.props.deleteContacts(ids, () => {
        this.props.getAllContacts(this.state.options, this.props.url)
      })
    }

    this.setState((state) => {
      //trigger resetting of selected rows
      return {
        ...state,
        isLoaded: !state.isLoaded,
      }
    })

    this.toggleDeleteContactsModal()
  }

  toggleDeleteContactsModal = () => {
    this.setState((state) => {
      return {
        ...state,
        isDeleteContactsModalToggle: !state.isDeleteContactsModalToggle,
      }
    })
  }

  toggleModal = () => {
    this.setState(
      (state) => {
        return {
          ...state,
          isModalToggle: !state.isModalToggle,
        }
      },
      () => {
        if (this.state.isModalToggle === false) {
          this.props.removeFiltersValues()
        }
      }
    )
  }

  toggleIsAssignWithTaskModal = () => {
    this.setState((state) => {
      return {
        ...state,
        isAssignWithTaskToggle: !state.isAssignWithTaskToggle,
      }
    })
  }

  toggleUserModal = () => {
    this.setState((state) => {
      return {
        ...state,
        isUserModalToggle: !state.isUserModalToggle,
      }
    })
  }

  toggleAddContactModal = () => {
    this.setState((state) => {
      return {
        ...state,
        isAddContactModal: !state.isAddContactModal,
      }
    })
  }

  toggleCombineModal = (e, selectedRows) => {
    if (selectedRows && selectedRows.length <= 1) {
      notificationDanger('Please select two or more contacts')
      return
    }
    this.props.setModal({
      id: 'combine_contacts',
      name: 'Combine Contacts',
      props: {
        selectedRows: selectedRows,
      },
    })
  }

  toggleChangeContactStatusModal = () => {
    this.props.setModal({
      id: 'change-contact-status',
      name: 'Change Contact Status',
    })
  }

  onPageChange = async (event) => {
    let that = this
    const pagination = { limit: event.rows, first: event.first }
    let options = { ...that.state.options, pagination }
    this.setState({ ...this.state, options }, async () => {
      const { pagination, sort, tableFilter } = this.state.options

      let prevQuery = {}
      if (this.props.history?.location?.search && this.props.url) {
        const decodedSearch = decodeURIComponent(this.props.history.location.search)
        const filtersFromUrl = JSON.parse(decodedSearch.substring(1))
        const { query } = filtersFromUrl
        prevQuery = { ...query }
      }

      const queryParams = encodeURIComponent(
        JSON.stringify({ query: { ...prevQuery, pagination, sort }, ...tableFilter })
      )

      this.props.history &&
        (await this.props.history.push({
          pathname: this.props.history.location.pathname,
          search: `?${queryParams}`,
        }))
      this.props.getAllContacts(that.state.options, this.props.url)
    })
  }

  onFilterChange = async (event) => {
    let tableFilter = { ...this.state.options.tableFilter }
    Object.keys(event.filters).forEach((key) => {
      tableFilter[key] = event.filters[key].value
      this.props.setFiltersValue(key, event.filters[key].value)
    })

    let options = {
      ...this.state.options,
      tableFilter: { ...this.state.options.tableFilter, ...tableFilter },
      // pagination: DEFAULT_PAGINATION,
    }
    this.setState({ ...this.state, options }, async () => {
      const { pagination, sort, tableFilter } = this.state.options
      let prevQuery = {}
      if (this.props.history?.location?.search && this.props.url) {
        const decodedSearch = decodeURIComponent(this.props.history.location.search)
        const filtersFromUrl = JSON.parse(decodedSearch.substring(1))
        const { query } = filtersFromUrl
        prevQuery = { ...query }
      }

      const queryParams = encodeURIComponent(
        JSON.stringify({ query: { ...prevQuery, pagination, sort }, ...tableFilter })
      )

      await this.props.history.push({
        pathname: this.props.history.location.pathname,
        search: `?${queryParams}`,
      })
      this.props.getAllContacts(options, this.props.url)
    })
  }

  handleSelectFilterChange = async (event) => {
    const { value, name } = event.target
    let tableFilter = { ...this.state.options.tableFilter }
    this.props.setFiltersValue(name || 'company_type_id', value)

    let options = {
      ...this.state.options,
      tableFilter: { ...this.state.options.tableFilter, ...tableFilter },
      pagination: DEFAULT_PAGINATION,
    }
    this.setState({ ...this.state, options }, () => {
      this.props.getAllContacts(this.state.options, this.props.url)
    })
  }

  onSortChange = async (event) => {
    let that = this
    let sort = {}

    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        sort[row.field] = row.order
      })
    }

    let options = { ...that.state.options, sort, pagination: { first: 0, limit: this.state.options.pagination.limit } }
    this.setState({ ...this.state, options }, async () => {
      const { pagination, sort, tableFilter } = this.state.options

      let prevQuery = {}
      if (this.props.history?.location?.search && this.props.url) {
        const decodedSearch = decodeURIComponent(this.props.history.location.search)
        const filtersFromUrl = JSON.parse(decodedSearch.substring(1))
        const { query } = filtersFromUrl
        prevQuery = { ...query }
      }

      const queryParams = encodeURIComponent(
        JSON.stringify({ query: { ...prevQuery, pagination, sort }, ...tableFilter })
      )

      this.props.history &&
        (await this.props.history.push({
          pathname: this.props.history.location.pathname,
          search: `?${queryParams}`,
        }))

      this.props.getAllContacts(that.state.options, this.props.url)
    })
  }

  changeOptionsData = async (options) => {
    const { pagination, sort, tableFilter } = options
    const filteredTableFilters = filterObject(tableFilter)

    this.setState(
      {
        ...this.state,
        options: {
          ...options,
          tableFilter: filteredTableFilters,
        },
      },
      async () => {
        const queryParams = encodeURIComponent(JSON.stringify({ query: { pagination, sort }, ...filteredTableFilters }))

        await this.props.history.push({
          pathname: this.props.history.location.pathname,
          search: `?${queryParams}`,
        })
        this.props.getAllContacts(this.state.options)
      }
    )
  }

  checkIsAssigneFunctionality = (withoutManager) => {
    const { permissions } = this.props
    const isAssigneButtonVisible =
      (permissions.includes(MANAGER) || withoutManager) && !permissions.includes(IS_EXECUTIVE)
    return isAssigneButtonVisible
  }

  getSelectedRows = (row) => {
    this.setState({ selectedRowsNew: row })
  }

  toggleRelatedEntitiesModal = (rowData) => {
    this.props.setModal({
      id: 'related_entities',
      name: 'Possible Duplicates',
      props: {
        contact: rowData,
      },
    })
  }

  render() {
    const {
      selectedRowsNew,
      isModalToggle,
      isUserModalToggle,
      isAddContactModal,
      selectedRows,
      isLoaded,
      tableFilter,
      options,
      isCombineModalToggle,
      isAssignWithTaskToggle,
      isDeleteContactsModalToggle,
      isExcelExportDisabled,
    } = this.state
    const {
      companyTypeOptons,
      isLoading,
      showAdd,
      hiddeRightButtonsAndContact,
      // isShowActions = true,
      isExecutive,
      hasDeleteContactPermission,
      tableName,
      canUploadNewLeads,
      hasChangeContactStatus,
    } = this.props
    var that = this

    const rightButtons = (selectedRow) => {
      return (
        <>
          {tableName === 'New Leads' && canUploadNewLeads && <ImportLeads modalName='Import New Leads' />}
          {isExecutive && (
            <>
              <ExcelButton
                id='export-contacts-to-excel'
                label='Export Contacts To Excel'
                disabled={isExcelExportDisabled}
                enableTooltip
                style={{ marginBottom: '2px', marginRight: '0.75rem' }}
                onClick={() => {
                  this.setState((prev) => ({ ...prev, isExcelExportDisabled: true }))

                  downloadContacts({
                    fileName: 'Contacts',
                    url: '/contacts',
                    options: { ...options, exportType: 'excel' },
                    callback: () => {
                      this.setState((prev) => ({ ...prev, isExcelExportDisabled: false }))
                    },
                  })
                }}
              />
            </>
          )}
          {hasChangeContactStatus && (
            <Button
              size='sm'
              className='btn btn-gold mr-2'
              style={{ marginBottom: '2px' }}
              onClick={this.toggleChangeContactStatusModal}
            >
              Change Contact Status
            </Button>
          )}
          {isExecutive && (
            <>
              <Button
                size='sm'
                onClick={(e) => this.toggleCombineModal(e, selectedRow)}
                className='btn btn-gold mr-2'
                style={{ marginBottom: '2px' }}
                disabled={isEmptyArray(selectedRowsNew)}
              >
                Combine Contacts
              </Button>
            </>
          )}
          {tableName === 'All Contacts' && hasDeleteContactPermission && (
            <Button
              size='sm'
              onClick={(e) => this.toggleDeleteContactsModal(e, selectedRow)}
              className='btn btn-danger mr-2'
              style={{ marginBottom: '2px' }}
              disabled={isEmptyArray(selectedRowsNew)}
            >
              Delete
            </Button>
          )}
          {tableName === 'To Reassign' && (
            <Button
              onClick={() => handleUnassignClick(selectedRow)}
              size='sm'
              className='btn btn-gold mr-2'
              style={{ marginBottom: '2px' }}
              disabled={isEmptyArray(selectedRowsNew)}
            >
              Unassign
            </Button>
          )}
          <Button
            onClick={() => getSelectedRows(selectedRow)}
            size='sm'
            className='btn btn-gold mr-2'
            style={{ marginBottom: '2px' }}
            disabled={isEmptyArray(selectedRowsNew)}
          >
            Assign
          </Button>
          <Button
            onClick={() => handleAssignWithTaskClick(selectedRow)}
            size='sm'
            className='btn btn-gold mr-2'
            style={{ marginBottom: '2px' }}
            disabled={isEmptyArray(selectedRowsNew)}
          >
            Assign With Task
          </Button>
        </>
      )
    }

    const leftButtons = () => {
      return (
        <Button onClick={that.toggleModal} size='sm' className='btn btn-gold ml-2' style={{ marginBottom: '2px' }}>
          Advance Search
        </Button>
      )
    }

    // let checkBoxFilter = <CustomSwitchComponent className='mt-3' name='is_active' onChange={this.handleSelectFilterChange} />;
    let dropDownFilter = (
      <CustomDropDownFilters
        style={{ width: '100%', zIndex: '99999 !important' }}
        options={companyTypeOptons}
        value={tableFilter && tableFilter.company_type_id}
        onChange={this.handleSelectFilterChange}
      />
    )

    const phoneNumber = (
      <CustomNumberFormat
        className={'form-control-sm form-control'}
        name='business_phone'
        value={options.tableFilter.business_phone}
        placeholder='Business Phone'
        type='tel'
        format='(999) 999-9999'
        onChange={(e) => this.handleSelectFilterChange(e)}
        size={10}
        hidePhoneIcon
      />
    )

    const phoneColumn = (rowData) => {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <CustomNumberFormat
            className={'form-control-sm form-control'}
            name='office_phone'
            value={rowData.businessPhone || ''}
            placeholder='Office Phone'
            type='tel'
            disabled
            format='(999) 999-9999'
            size={10}
            contactId={rowData.id}
            contactName={rowData.name}
            activityType={OUT_GOING_CALL}
          />
        </div>
      )
    }

    const relatedEntitiesBody = (rowData) => {
      return (
        <div>
          <Button size='sm' className='gold-color-button' onClick={() => this.toggleRelatedEntitiesModal(rowData)}>
            Search <i className='fa fa-search' aria-hidden='true' />
          </Button>
        </div>
      )
    }

    const statusBody = (rowData) => {
      const mapStatus = (statusId) => {
        switch (statusId) {
          case LEAD_STATUS:
            return 'Lead'
          case PROSPECT_STATUS:
            return 'Prospect'
          case ACCOUNT_STATUS:
            return 'Account'
          case MANAGER_BUCKET_STATUS:
            return `Manager's Bucket`
          case INACTIVE_STATUS:
            return 'Inactive'
          case PENDING_STATUS:
            return 'Pending'
          default:
            return ''
        }
      }
      return <div>{mapStatus(rowData.divisions.statusId)}</div>
    }

    const stateName = (rowData) => {
      return getAmericaStateName(rowData.addressState)
    }

    const nameBody = (rowData) => {
      const openContactInNewTab = (e) => {
        e.preventDefault()

        if (this.props?.history?.location?.pathname && this.props.nameBodyLink) {
          window.open(`${this.props.history.location.pathname}/${rowData.id}`, '_blank')
        }
      }

      return (
        <>
          {rowData?.openedFlags?.length ? <i className='fas fa-flag text-danger' style={{ marginRight: '5px' }} /> : ''}
          {this.props.nameBodyLink ? (
            <Link to='#' onClick={openContactInNewTab} style={{ cursor: 'pointer' }}>
              {rowData.name}
            </Link>
          ) : (
            <>{rowData.name}</>
          )}
        </>
      )
    }

    const importedBody = (rowData) => {
      return (
        <>
          <span style={composeImportDateStyle(rowData.importDate)}>
            {timeWithoutTimeZone(rowData.importDate, 'YYYY-MM-DD')}
          </span>
        </>
      )
    }

    const composeImportDateStyle = (date) => {
      let color = 'black'
      if (date) {
        const today = moment()
        const duration = moment.duration(today.diff(date))

        const difference = duration.asHours()
        if (difference) {
          if (difference <= 72 && difference > 48) {
            color = 'red'
          } else if (difference <= 48 && difference > 24) {
            color = '#cbce0f' // yellow
          } else if (difference <= 24) {
            color = '#53e691' // green
          }
        }
      }
      return {
        color,
      }
    }

    const dotNumberBody = (rowData) => {
      let dotNumber = rowData?.dotNumber

      return (
        <Link
          rel='noopener noreferrer'
          onClick={() =>
            window.open(
              `https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=USDOT&query_string=${dotNumber}`,
              '_blank'
            )
          }
        >
          {dotNumber}
        </Link>
      )
    }

    const mcNumberBody = (rowData) => {
      let mcNumber = rowData?.mcNumber

      return (
        <Link
          rel='noopener noreferrer'
          onClick={() =>
            window.open(
              `https://safer.fmcsa.dot.gov/query.asp?searchtype=ANY&query_type=queryCarrierSnapshot&query_param=MC_MX&query_string=${mcNumber}`,
              '_blank'
            )
          }
        >
          {mcNumber}
        </Link>
      )
    }

    const defaultColumns = [
      { field: 'name', header: 'Name', body: nameBody, style: { width: '11.5%' } },
      { field: 'organizationtype.name', header: 'Org. Type', style: { width: '7%' } },
      { field: 'dotNumber', header: 'US DOT', body: dotNumberBody, style: { width: '5%' } },
      { field: 'mcNumber', header: 'MC Number', body: mcNumberBody, style: { width: '5%' } },
      { field: 'addressState', header: 'State', body: stateName, style: { width: '7%' } },
      { field: 'numberOfTrucks', header: '# of trucks', style: { width: '4.25%' } },
      { field: 'ownerName', header: 'Company Owner', style: { width: '9%' } },
      { field: 'nationality.name', header: 'Preferred Language', style: { width: '7%' } },
      {
        field: 'companytype.name',
        header: 'Company Type',
        filterElement: dropDownFilter,
      },
      {
        field: 'businessPhone',
        header: 'Business Phone',
        body: phoneColumn,
        style: { width: '10%' },
        filterElement: phoneNumber,
      },
      // { field: 'email', header: 'Email' },
      {
        field: 'lastContactDate',
        header: 'Last Contact Date',
        format: 'MM-DD-YYYY',
      },
      {
        field: 'lastMeetingDate',
        header: 'Last Meeting Date',
        format: 'MM-DD-YYYY',
      },
    ]

    if (this.state.options.filter?.recentLeads) {
      defaultColumns.unshift({ field: 'importDate', header: 'Imported', body: importedBody })
    }

    if (this.checkIsAssigneFunctionality('withoutManager')) {
      defaultColumns.push({ field: 'users.name', header: 'Assigned User' })
    }

    if (tableName === 'To Reassign') {
      defaultColumns.push({
        field: 'divisions.statusId',
        header: 'Status',
        body: statusBody,
      })
    }

    defaultColumns.push({
      field: 'relatedEntities',
      header: 'Related Entities',
      body: relatedEntitiesBody,
      style: { width: '105px' },
      sortable: false,
    })

    if (tableName === 'Collection List') {
      defaultColumns.push({
        field: 'currentBalance',
        header: 'Current Balance',
      })
      defaultColumns.push({
        field: 'daysLate',
        header: 'Days Late',
      })
      defaultColumns.push({
        field: 'lastCollectionActivity',
        header: 'Last Collection Activity',
      })
    }

    const getSelectedRows = (selectedRowsData) => {
      this.setState(
        (state) => {
          return {
            ...state,
            selectedRows: selectedRowsData,
          }
        },
        () => {
          this.toggleUserModal()
        }
      )
    }
    const handleUnassignClick = (selectedRowsData) => {
      this.setState(
        (state) => {
          return {
            ...state,
            selectedRows: selectedRowsData,
          }
        },
        () => {
          this.props.unassignContacts(
            {
              divisionId: this.props.divisionId,
              selectedRows: this.state.selectedRows,
            },
            this.state.options
          )
        }
      )
    }

    const handleAssignWithTaskClick = (selectedRowsData) => {
      this.setState(
        (state) => {
          return {
            ...state,
            selectedRows: selectedRowsData,
          }
        },
        () => {
          this.props.assignWithTask(
            this.state.selectedRows,
            () => {
              this.loadDataWithFilters()
            },
            this.props.isMasterData,
            this.props.isToReassign
          )
        }
      )
    }

    const sortMeta = () => {
      if (this.state.options?.sort) {
        const field = Object.keys(this.state.options?.sort)[0]
        const order = this.state.options?.sort[field]

        return [
          {
            field,
            order,
          },
        ]
      } else {
        return DEFAULT_SORT_META
      }
    }

    const isRowSelectable = (data) => {
      const canAssignTeam = this.props.permissions.some((permission) => [MANAGER, BRANCH_MANAGER].includes(permission))
      const isAssignable = isContactAssignable(data?.users?.id, this.props.myTeam, {
        isAssignable: !!this.props.isToReassign,
        currentUserId: this.props.userId,
        canAssignTeam,
      })

      return isAssignable
    }

    return (
      <>
        {isLoading && <Loader />}
        <CustomModal isOpen={isModalToggle} toggle={that.toggleModal} headerText={'Advanced Search'} big>
          <SelectingFilters
            filterCategory={CONTACT}
            loadData={this.toggleModal}
            query={this.props?.url?.query ? this.props.url.query : this.props.query}
            previousTableFilters={this.state.options.tableFilter}
          />
        </CustomModal>
        {/* <CustomModal isOpen={isCombineModalToggle} toggle={that.toggleCombineModal} headerText={'Combine Contacts'} big>
          <CombineContacts selectedRows={selectedRows} loadData={that.loadDataWithFilters} />
        </CustomModal> */}
        <CustomPopupModal
          isOpen={isDeleteContactsModalToggle}
          toggle={this.toggleDeleteContactsModal}
          headerText={'Delete Contacts'}
          className='modal-danger'
        >
          <DeleteContacts
            selectedRows={selectedRowsNew}
            toggleModal={this.toggleDeleteContactsModal}
            deleteAndLoadDataWithFilters={this.deleteAndLoadDataWithFilters}
            message={
              isNotEmptyArray(selectedRowsNew)
                ? `Are You sure you want to delete following contacts:`
                : 'No contacts selected'
            }
          />
        </CustomPopupModal>
        <CustomPopupModal
          isOpen={isUserModalToggle}
          toggle={that.toggleUserModal}
          headerText={'Select User'}
          className='modal-warning'
        >
          <SelectUserToAssigne
            isMasterData={this.props.isMasterData}
            history={this.props.history}
            selectedRows={selectedRows}
            loadData={this.loadDataWithFilters}
            toggleModal={this.toggleUserModal}
          />
        </CustomPopupModal>
        <CustomModal isOpen={isAddContactModal} toggle={that.toggleAddContactModal} headerText={'Add Contact'}>
          <AddNewContact history={this.props.history} selectedRows={selectedRows} loadData={this.loadDataWithFilters} />
        </CustomModal>
        <ContactTableFilters changeOptionsData={this.changeOptionsData} optionsFromContactTable={this.state.options} />
        <Card className='card-contact'>
          {!hiddeRightButtonsAndContact && <CardHeader>{tableName}</CardHeader>}
          <CardBody>
            {/* <CustomModalTemplate Component={RelatedEntities} /> */}
            <Row>
              <Col>
                <CustomPrimeTable
                  isRowSelectable={isRowSelectable}
                  defaultSortMeta={sortMeta()}
                  columnResizeMode={COLUMN_RESIZE_EXPAND}
                  card='card-contact'
                  isLoaded={isLoaded}
                  selectionMode='multiple'
                  excelExport={
                    !hiddeRightButtonsAndContact && {
                      limit: EXCEL_DEFAULT_LIMIT,
                      options: EXCEL_OPTIONS,
                      url: URL_PARAM,
                      fileName: EXCEL_FILE_NAME,
                    }
                  }
                  data={that.props.contacts.data}
                  selectRows={!hiddeRightButtonsAndContact}
                  findHidden={true}
                  columns={this.props.columns || defaultColumns}
                  rightButtons={!hiddeRightButtonsAndContact && rightButtons}
                  leftButtons={leftButtons}
                  onPage={that.onPageChange}
                  onSort={that.onSortChange}
                  addHidden={!showAdd}
                  onFilter={that.onFilterChange}
                  query={that.props.contacts.query}
                  onEdit={(rowData) => {
                    // that.props.history &&
                    //   that.props.history.push(
                    //     `/${this.props?.routeType ? routesMap.get(this.props.routeType) : 'contacts'}/${rowData.id}`
                    //   )
                  }}
                  onSelectionChange={(e) => {
                    // !that.props.ignoreRowClick &&
                    //   that.props.history &&
                    //   that.props.history.push(
                    //     `/${this.props?.routeType ? routesMap.get(this.props.routeType) : 'contacts'}/${
                    //       e.value.id || e.data.contactId
                    //     }`
                    //   )
                  }}
                  onDelete={(rowData) => that.deleteContact(rowData.id)}
                  onAdd={() => this.toggleAddContactModal()}
                  newTab={true}
                  getSelectedRows={this.getSelectedRows}
                  // showActions={!hiddeRightButtonsAndContact}
                  showActions={false}
                  shownRelatedEntities
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  divisionId: state.auth.user.division_id,
  contacts: state.contacts.contacts,
  companyTypeOptons: state.contacts.companyTypeOptions,
  errors: state.errors,
  advanceFilters: state.contactFilters.filtersValues,
  isLoading: state.contacts.isLoading,
  permissions: state.auth.user.permissions,
  userId: state.auth.user.userId,
  isExecutive: state.auth.user.permissions.includes(IS_EXECUTIVE),
  hasDeleteContactPermission: state.auth.user.permissions.includes(DELETE_CONTACT_PERMISSION),
  canUploadNewLeads: state.auth.user.permissions.includes(CAN_UPLOAD_NEW_LEADS),
  hasChangeContactStatus: state.auth.user.permissions.includes(CHANGE_CONTACT_STATUS),
  myTeam: state.users.myTeam.map((user) => user.id),
})

const connected = connect(mapStateToProps, {
  getAllContacts,
  deleteContact,
  deleteContacts,
  setFiltersValue,
  getOptions,
  setFiltersOnLoad,
  assignWithTask,
  setModal,
  removeFiltersValues,
  unassignContacts,
})

export default withRouter(connected(index))
